import { ALLOCATION_ROUTE, Allocation } from "@taskmanagement/taskapp-model";
import { BaseService } from "./base-service";

const url = ALLOCATION_ROUTE;
export class AllocationService extends BaseService<Allocation> {
  constructor() {
    super(url);
  }
}
